import React from 'react'
import { formatDateStandard } from '../../../../global/formatters/string-formatter'
import Tooltip from '../../../Tooltip/Tooltip.jsx'
import {
  getMutualFundTooltipContent,
  getTooltipContentByKey,
} from '../../../Tooltip/tooltipUtil'

function OverviewYields({ sevenDayYields }) {
  const motualFundTooltipData = getMutualFundTooltipContent()

  return (
    <div className="Content u-paddingVert0" id="seven-day-yields">
      <div id="ampf-trace-loaded-section-fund-story-seven-day-yields">
        <h3 className="u-marginTop0">Yields (%)</h3>
        <ul>
          {sevenDayYields?.currentValue && (
            <li className="u-decoUnbulleted u-marginHoriz0 u-marginBottom3gu u-sm-posRelative">
              <Tooltip
                heading={
                  getTooltipContentByKey(motualFundTooltipData, '7-day current')
                    ?.heading || '7-day current'
                }
                content={
                  getTooltipContentByKey(motualFundTooltipData, '7-day current')
                    ?.content || ''
                }
                direction="Tooltip-left"
                id="tooltip-7-day-current"
              >
                <h4>
                  <span className="u-textColorLight u-textSecondary Tooltip-label">
                    7-day current
                  </span>
                  <span className="Icon--material Tooltip-icon u-marginLeft1gu">
                    info
                  </span>
                </h4>
              </Tooltip>
              <p className="u-textSizeMsrp3 u-textSecondary u-sm-textSizeMsrp1 u-marginBottom0">
                {sevenDayYields.currentValue}
              </p>
              <p className="u-textColorLight u-textSizeMsrm1 u-textSecondary">
                as of {formatDateStandard(sevenDayYields.currentDate)}
              </p>
            </li>
          )}
          {sevenDayYields?.unSubValue && (
            <li className="u-decoUnbulleted u-marginHoriz0 u-marginBottom3gu u-sm-posRelative">
              <Tooltip
                heading={
                  getTooltipContentByKey(
                    motualFundTooltipData,
                    '7-day unsubsidized'
                  )?.heading || '7-day unsubsidized'
                }
                content={
                  getTooltipContentByKey(
                    motualFundTooltipData,
                    '7-day unsubsidized'
                  )?.content || ''
                }
                direction="Tooltip-left"
                id="tooltip-7-day-unsubsidized"
              >
                <h4>
                  <span className="u-textColorLight u-textSecondary Tooltip-label">
                    7-day unsubsidized
                  </span>
                  <span className="Icon--material Tooltip-icon u-marginLeft1gu">
                    info
                  </span>
                </h4>
              </Tooltip>
              <p className="u-textSizeMsrp3 u-textSecondary u-sm-textSizeMsrp1 u-marginBottom0">
                {sevenDayYields.unSubValue}
              </p>
              <p className="u-textColorLight u-textSizeMsrm1 u-textSecondary">
                as of {formatDateStandard(sevenDayYields.unSubDate)}
              </p>
            </li>
          )}
          {sevenDayYields?.effectiveValue && (
            <li className="u-decoUnbulleted u-marginHoriz0 u-marginBottom3gu u-sm-posRelative">
              <Tooltip
                heading={
                  getTooltipContentByKey(
                    motualFundTooltipData,
                    '7-day effective'
                  )?.heading || '7-day effective'
                }
                content={
                  getTooltipContentByKey(
                    motualFundTooltipData,
                    '7-day effective'
                  )?.content || ''
                }
                direction="Tooltip-left"
                id="tooltip-7-day-effective"
              >
                <h4>
                  <span className="u-textColorLight u-textSecondary Tooltip-label">
                    7-day effective
                  </span>
                  <span className="Icon--material Tooltip-icon u-marginLeft1gu">
                    info
                  </span>
                </h4>
              </Tooltip>
              <p className="u-textSizeMsrp3 u-textSecondary u-sm-textSizeMsrp1 u-marginBottom0">
                {sevenDayYields.effectiveValue}
              </p>
              <p className="u-textColorLight u-textSizeMsrm1 u-textSecondary">
                as of {formatDateStandard(sevenDayYields.effectiveDate)}
              </p>
            </li>
          )}
        </ul>
      </div>
    </div>
  )
}

export default OverviewYields
